/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';
import { ArrowUpward, ArrowDownward, UnfoldMore } from '@mui/icons-material';
import './SortableTableHeader.css';

/**
 * Sortable table header component
 * @param {string} column - The column identifier for sorting
 * @param {string} label - The display label for the column
 * @param {string} currentSortColumn - The currently active sort column
 * @param {string} sortOrder - Current sort order ('asc' or 'desc')
 * @param {function} onSort - Callback function when header is clicked
 * @param {boolean} sortable - Whether this column is sortable (default: true)
 */
const SortableTableHeader = ({ 
  column, 
  label, 
  currentSortColumn, 
  sortOrder, 
  onSort,
  sortable = true 
}) => {
  const isActive = currentSortColumn === column;

  if (!sortable) {
    return <th>{label}</th>;
  }

  return (
    <th 
      className="sortable-header" 
      onClick={() => onSort(column)}
      style={{ cursor: 'pointer', userSelect: 'none' }}
    >
      <div className="header-content">
        <span>{label}</span>
        <span className="sort-icon">
          {!isActive && <UnfoldMore style={{ fontSize: '18px', opacity: 0.4 }} />}
          {isActive && sortOrder === 'asc' && (
            <ArrowUpward style={{ fontSize: '18px', color: '#1976d2' }} />
          )}
          {isActive && sortOrder === 'desc' && (
            <ArrowDownward style={{ fontSize: '18px', color: '#1976d2' }} />
          )}
        </span>
      </div>
    </th>
  );
};

export default SortableTableHeader;

